import CartActionTypes from "../../actionTypes/cart"
import { getCart } from "../../reducers"
import { getCartItems, updateCart } from "../../../services/cartHelper"

const removeAction = (lineItemIds) => (dispatch, getState) => {
  if (!lineItemIds) {
    console.error("Product line item IDs are required")
    return
  }

  const { checkout, client, removing, removed } = getCart(getState())

  if (!checkout) {
    console.error("A checkout is required")
    return
  }

  let isRemovingOrRemoved = true

  for (let i = 0; i < lineItemIds.length; i++) {
    const lineItemId = lineItemIds[i]

    if (!removing.includes(lineItemId) || !removed.includes(lineItemId)) {
      isRemovingOrRemoved = false
    }
  }

  if (!isRemovingOrRemoved) {
    const updatedRemoving = [...removing, ...lineItemIds] // Create a new array
    dispatch({
      type: CartActionTypes.REMOVING_ACTION,
      payload: {
        removing: updatedRemoving,
      },
    })
  }

  const isBrowser = typeof window !== "undefined"
  let items = []

  if (isBrowser) {
    items = getCartItems()
  }

  const lineItemsToRemove = lineItemIds
  const checkoutId = checkout.id

  return client.checkout
    .removeLineItems(checkoutId, lineItemsToRemove)
    .then((checkout) => {
      processCartUpdate(dispatch, items, checkout, lineItemsToRemove, removed)
    })
    .catch((error) => {
      console.error(error.message)
    })
}

function processCartUpdate(dispatch, items, checkout, lineItemIds, removed) {
  let cartData = updateCart(items, checkout)

  //create and parse a deep copy of the cartData to avoid mutation
  let newPayload = JSON.parse(JSON.stringify(cartData))

  dispatch({
    type: CartActionTypes.REMOVE_ACTION,
    payload: {
      ...newPayload,
      isAdded: false,
    },
  })

  let removedItems = []

  removed.forEach((removedItem) => {
    removedItems.push(removedItem)
  })

  lineItemIds.forEach((removedItem) => {
    removedItems.push(removedItem)
  })

  dispatch({
    type: CartActionTypes.REMOVED_ACTION,
    payload: {
      removed: removedItems,
    },
  })
}

export { removeAction }
